import React from 'react';
import './EmptyState.css';
const EmptyState = ({ message, ctaLabel, onCta, hint }) => (
  <div className="empty-state">
    <p className="empty-state-message">{message}</p>
    {hint && <p className="empty-state-hint">{hint}</p>}
    {ctaLabel && onCta && (<button type="button" className="empty-state-cta" onClick={onCta}>{ctaLabel}</button>)}
  </div>
);
export default EmptyState;
